import type { SVGProps } from 'react';

type LibIconSVGProps = SVGProps<SVGSVGElement> & {
  fill?: string;
  isPdf?: boolean;
  size?: number;
};

export function HourglassTopOutlined({ fill = '#222', isPdf = false, size = 18, ...props }: LibIconSVGProps) {
  if (isPdf) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="13"
        height="13"
        viewBox="0 0 13 13"
        fill="none"
        // Adjust scale and margin for PDF context
        style={{ transform: 'scale(1.2)', marginRight: '-4px', marginTop: '2px' }}
        {...props}
      >
        <path
          d="M2.5 0.833374L2.50417 3.33337L4.16667 5.00004L2.50417 6.67087L2.5 9.16671H7.5V6.66671L5.83333 5.00004L7.5 3.33754V0.833374H2.5ZM6.66667 6.87504V8.33337H3.33333V6.87504L5 5.20837L6.66667 6.87504Z"
          fill="#EF6C00"
        />
      </svg>
    );
  }

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 18 18" fill="none" {...props}>
      <path
        fill={fill}
        d="m5 2.167.008 5L8.333 10.5l-3.325 3.342L5 18.833h10v-5L11.667 10.5 15 7.175V2.167zm8.333 12.083v2.916H6.667V14.25L10 10.916z"
      />
    </svg>
  );
}

export default HourglassTopOutlined;
